// // src/pages/Todo/QuickAdd.tsx
// import React, { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Plus, Calendar, Flag, Bell, Repeat, X, CheckCircle2 } from "lucide-react";
// import { format } from "date-fns";
// import type { TodoPriority, TodoQuickAdd } from "../../api/todo";
// import { toast } from "sonner";

// const PRIORITIES: { v: TodoPriority; label: string; color: string }[] = [
//   { v: "URGENT", label: "Urgent", color: "text-red-600" },
//   { v: "HIGH", label: "High", color: "text-orange-600" },
//   { v: "MEDIUM", label: "Medium", color: "text-blue-600" },
//   { v: "LOW", label: "Low", color: "text-emerald-600" },
// ];

// interface Props {
//   onCreate: (payload: TodoQuickAdd) => Promise<void>;
//   defaultDate?: Date;
// }

// // Modern DateTime Picker Component with Portal support
// const ModernDateTimePicker: React.FC<{
//   value: string;
//   onChange: (value: string) => void;
//   placeholder?: string;
//   icon?: React.ReactNode;
// }> = ({ value, onChange, placeholder = "Select date", icon }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [tempDate, setTempDate] = useState(value || format(new Date(), "yyyy-MM-dd'T'HH:mm"));
//   const buttonRef = useRef<HTMLButtonElement>(null);
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
//         buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
//         setIsOpen(false);
//       }
//     };

//     const handleScroll = () => {
//       if (isOpen) setIsOpen(false);
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     window.addEventListener('scroll', handleScroll, true);

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//       window.removeEventListener('scroll', handleScroll, true);
//     };
//   }, [isOpen]);

//   useEffect(() => {
//     if (isOpen && buttonRef.current) {
//       const rect = buttonRef.current.getBoundingClientRect();
//       setDropdownPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//       });
//     }
//   }, [isOpen]);

//   const handleConfirm = () => {
//     onChange(tempDate);
//     setIsOpen(false);
//   };

//   const handleClear = () => {
//     onChange('');
//     setIsOpen(false);
//   };

//   const displayValue = () => {
//     if (!value) return placeholder;
//     try {
//       return format(new Date(value), "MMM d, h:mm a");
//     } catch {
//       return placeholder;
//     }
//   };

//   return (
//     <>
//       <button
//         ref={buttonRef}
//         type="button"
//         onClick={() => setIsOpen(!isOpen)}
//         className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-xl border bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 transition-all"
//       >
//         {icon || <Calendar className="w-4 h-4" />}
//         <span className="text-sm whitespace-nowrap">{displayValue()}</span>
//       </button>

//       {isOpen && (
//         <div
//           ref={dropdownRef}
//           style={{
//             position: 'fixed',
//             top: `${dropdownPosition.top}px`,
//             left: `${dropdownPosition.left}px`,
//             zIndex: 99999,
//           }}
//           className="mt-1"
//         >
//           <div className="bg-white dark:bg-gray-900 border rounded-2xl shadow-2xl p-5 w-[320px]">
//             <div className="space-y-4">
//               <div>
//                 <label className="text-xs font-medium text-gray-600 dark:text-gray-400 block mb-2">Date</label>
//                 <input
//                   type="date"
//                   value={tempDate.split('T')[0]}
//                   onChange={(e) => setTempDate(prev => `${e.target.value}T${prev.split('T')[1] || '12:00'}`)}
//                   className="w-full px-3 py-2 text-sm border rounded-xl bg-gray-50 dark:bg-gray-800 focus:ring-2 focus:ring-indigo-500 outline-none"
//                 />
//               </div>
//               <div>
//                 <label className="text-xs font-medium text-gray-600 dark:text-gray-400 block mb-2">Time</label>
//                 <input
//                   type="time"
//                   value={tempDate.split('T')[1] || '12:00'}
//                   onChange={(e) => setTempDate(prev => `${prev.split('T')[0]}T${e.target.value}`)}
//                   className="w-full px-3 py-2 text-sm border rounded-xl bg-gray-50 dark:bg-gray-800 focus:ring-2 focus:ring-indigo-500 outline-none"
//                 />
//               </div>
//               <div className="flex gap-2 pt-2">
//                 <button
//                   onClick={handleConfirm}
//                   className="flex-1 px-4 py-2 text-sm bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-xl hover:shadow-lg transition"
//                 >
//                   Confirm
//                 </button>
//                 {value && (
//                   <button
//                     onClick={handleClear}
//                     className="px-4 py-2 text-sm border rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition"
//                   >
//                     Clear
//                   </button>
//                 )}
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="px-4 py-2 text-sm border rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default function QuickAdd({ onCreate, defaultDate }: Props) {
//   const [open, setOpen] = useState(true);
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [priority, setPriority] = useState<TodoPriority>("MEDIUM");
//   const [dueDate, setDueDate] = useState<string>(() => {
//     const d = defaultDate || new Date();
//     d.setHours(18, 0, 0, 0);
//     return format(d, "yyyy-MM-dd'T'HH:mm");
//   });
//   const [reminderAt, setReminderAt] = useState<string>("");
//   const [isRecurring, setIsRecurring] = useState(false);
//   const [interval, setInterval] = useState<"DAILY" | "WEEKLY" | "MONTHLY">("DAILY");
//   const [markCompleted, setMarkCompleted] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const inputRef = useRef<HTMLInputElement>(null);
//   const containerRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (open) inputRef.current?.focus();
//   }, [open]);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       // DO NOTHING → prevent auto close
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const reset = () => {
//     setTitle("");
//     setDescription("");
//     setPriority("MEDIUM");
//     setReminderAt("");
//     setIsRecurring(false);
//     setMarkCompleted(false);
//   };

//   const submit = async (e?: React.FormEvent) => {
//     e?.preventDefault();
//     if (!title.trim() || submitting) return;
//     setSubmitting(true);
//     try {
//       await onCreate({
//         title: title.trim(),
//         description: description.trim() || undefined,
//         priority,
//         status: markCompleted ? "COMPLETED" : "PENDING",
//         due_date: dueDate ? format(new Date(dueDate), "yyyy-MM-dd") : undefined,
//         reminder_at: reminderAt ? new Date(reminderAt).toISOString() : undefined,
//         is_recurring: isRecurring,
//         recurrence_rule: isRecurring ? { interval, every: 1 } : undefined,
//       });
//       reset();
//       setOpen(false);
//       toast.success("Task added successfully!");
//     } catch (error: any) {
//       toast.error("Couldn't add task", { description: error?.response?.data?.detail || error.message });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div ref={containerRef} className="rounded-2xl border bg-gradient-to-br from-card via-card to-muted/30 shadow-sm relative">
//       {!open ? (
//         <button
//           type="button"
//           onClick={() => setOpen(true)}
//           className="w-full flex items-center gap-3 px-5 py-4 transition-all hover:bg-muted/40"
//         >
//           <span className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
//             <Plus className="w-5 h-5" />
//           </span>
//           <span className="text-sm text-muted-foreground">Quick-add a task… (e.g. "Finish payroll review")</span>
//           <kbd className="ml-auto hidden md:inline-flex items-center gap-1 text-[10px] text-muted-foreground border rounded px-1.5 py-0.5">N</kbd>
//         </button>
//       ) : (
//         <motion.form
//           initial={{ height: 0, opacity: 0 }}
//           animate={{ height: "auto", opacity: 1 }}
//           exit={{ height: 0, opacity: 0 }}
//           transition={{ duration: 0.2 }}
//           className="overflow-visible"
//           onSubmit={submit}
//         >
//           <div className="p-5 space-y-3">
//             <div className="flex items-center gap-3">
//               <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md shrink-0">
//                 <Plus className="w-5 h-5" />
//               </div>
//               <input
//                 ref={inputRef}
//                 type="text"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 placeholder="What needs doing?"
//                 className="flex-1 bg-transparent border-0 outline-none text-base font-medium placeholder:text-muted-foreground/60"
//                 onKeyDown={(e) => {
//                   if (e.key === "Escape") {
//                     setOpen(false);
//                     reset();
//                   }
//                   if (e.key === "Enter" && !e.shiftKey) {
//                     e.preventDefault();
//                     submit();
//                   }
//                 }}
//               />
//               <button
//                 type="button"
//                 onClick={() => { setOpen(false); reset(); }}
//                 className="text-muted-foreground hover:text-foreground"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             <textarea
//               value={description}
//               onChange={(e) => {
//                 setDescription(e.target.value);

//                 e.target.style.height = "auto";
//                 e.target.style.height = e.target.scrollHeight + "px";
//               }}
//               placeholder="Notes (optional)"
//               rows={2}
//               className="w-full bg-muted/40 rounded-lg p-2 text-sm border border-transparent focus:border-ring focus:bg-background outline-none resize-none transition overflow-hidden"
//             />

//             <div className="flex flex-wrap gap-2 items-center relative">
//               <ModernDateTimePicker
//                 value={dueDate}
//                 onChange={setDueDate}
//                 icon={<Calendar className="w-4 h-4" />}
//               />

//               <div className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg border bg-background">
//                 <Flag className="w-3.5 h-3.5" />
//                 <select
//                   value={priority}
//                   onChange={(e) => setPriority(e.target.value as TodoPriority)}
//                   className="bg-transparent text-xs outline-none cursor-pointer"
//                 >
//                   {PRIORITIES.map((p) => (
//                     <option key={p.v} value={p.v}>{p.label}</option>
//                   ))}
//                 </select>
//               </div>

//               <ModernDateTimePicker
//                 value={reminderAt}
//                 onChange={setReminderAt}
//                 placeholder="Reminder"
//                 icon={<Bell className="w-4 h-4" />}
//               />

//               <button
//                 type="button"
//                 onClick={() => setIsRecurring((v) => !v)}
//                 className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-lg border transition ${isRecurring ? "bg-violet-100 text-violet-700 border-violet-300 dark:bg-violet-950/40 dark:text-violet-300" : "bg-background hover:bg-muted/40"
//                   }`}
//               >
//                 <Repeat className="w-3.5 h-3.5" /> Recurring
//               </button>

//               {isRecurring && (
//                 <select
//                   value={interval}
//                   onChange={(e) => setInterval(e.target.value as any)}
//                   className="text-xs px-2 py-1.5 rounded-lg border bg-background outline-none"
//                 >
//                   <option value="DAILY">Daily</option>
//                   <option value="WEEKLY">Weekly</option>
//                   <option value="MONTHLY">Monthly</option>
//                 </select>
//               )}

//               <button
//                 type="button"
//                 onClick={() => setMarkCompleted((v) => !v)}
//                 className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-lg border transition ${markCompleted
//                     ? "bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-950/40 dark:text-emerald-300"
//                     : "bg-background hover:bg-muted/40"
//                   }`}
//                 title="Add as already completed"
//               >
//                 <CheckCircle2 className="w-3.5 h-3.5" /> Completed
//               </button>

//               <button
//                 type="submit"
//                 disabled={!title.trim() || submitting}
//                 className="ml-auto inline-flex items-center gap-1.5 text-sm px-4 py-2 rounded-lg bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition"
//               >
//                 {submitting ? "Planning..." : "Plan"}
//                 <kbd className="hidden md:inline-flex text-[10px] opacity-80 border border-white/40 rounded px-1">⏎</kbd>
//               </button>
//             </div>
//           </div>
//         </motion.form>
//       )}
//     </div>
//   );
// }



// src/pages/Todo/QuickAdd.tsx
import React, { useState, useRef, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Calendar, Flag, Bell, Repeat, X, CheckCircle2, ChevronLeft, ChevronRight, Users, Search, Check, Building2, Truck, FolderKanban, Paperclip, Loader2 } from "lucide-react";
import { format } from "date-fns";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import type { TodoPriority, TodoQuickAdd, TodoAttachment } from "../../api/todo";
import { todoApi, attachmentHref } from "../../api/todo";
import { getAllUsers, type User as ApiUser } from "../../api/user";
import { clientsApi, type Client } from "../../api/clients";
import { vendorsApi, type Vendor } from "../../api/vendors";
import { projectsApi, type Project } from "../../api/projects";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";

const PRIORITIES: { v: TodoPriority; label: string; color: string }[] = [
  { v: "URGENT", label: "Urgent", color: "text-red-600" },
  { v: "HIGH", label: "High", color: "text-orange-600" },
  { v: "MEDIUM", label: "Medium", color: "text-blue-600" },
  { v: "LOW", label: "Low", color: "text-emerald-600" },
];

// Extends TodoQuickAdd with optional assignee user_ids. When present, the
// planner pushes the entry onto each recipient's Daily Planner as a
// personal Todo (one row per user_id), not as a shared Task — the user
// only needs a lightweight todo for the assignee, not the full task
// lifecycle (reviewers, approval chain, etc).
export interface QuickAddPayload extends TodoQuickAdd {
  assignees?: string[];
}

interface Props {
  onCreate: (payload: QuickAddPayload) => Promise<void>;
  defaultDate?: Date;
}

// Smart DateTime Picker - Opens in best available position
const ModernDateTimePicker: React.FC<{
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}> = ({ value, onChange, placeholder = "Select date", icon, fullWidth }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempDate, setTempDate] = useState(value || format(new Date(), "yyyy-MM-dd'T'HH:mm"));
  const [currentMonth, setCurrentMonth] = useState(() => {
    const d = value ? new Date(value) : new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0, position: 'bottom' as 'top' | 'bottom' | 'center' });

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const calendarHeight = 380;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const windowWidth = window.innerWidth;
      const popupWidth = 280;
      
      // Calculate horizontal position (center on button, but keep in viewport)
      let left = rect.left + window.scrollX + (rect.width / 2) - (popupWidth / 2);
      left = Math.max(10, Math.min(left, windowWidth - popupWidth - 10));
      
      // Determine vertical position based on available space
      let top = 0;
      let position: 'top' | 'bottom' | 'center' = 'bottom';
      
      if (spaceBelow >= calendarHeight) {
        // Open below if enough space
        top = rect.bottom + window.scrollY + 5;
        position = 'bottom';
      } else if (spaceAbove >= calendarHeight) {
        // Open above if enough space
        top = rect.top + window.scrollY - calendarHeight - 5;
        position = 'top';
      } else {
        // Open centered in viewport as modal
        top = window.scrollY + (window.innerHeight / 2) - (calendarHeight / 2);
        position = 'center';
        // Center the modal in the middle of the screen
        left = (windowWidth / 2) - (popupWidth / 2);
      }
      
      setPopupPosition({ top, left, position });
    }
  }, [isOpen]);

  const handleDateSelect = (dateStr: string) => {
    setTempDate(dateStr);
    setTimeout(() => {
      onChange(dateStr);
      setIsOpen(false);
    }, 150);
  };

  const handleConfirm = () => {
    onChange(tempDate);
    setIsOpen(false);
  };

  const handleClear = () => {
    onChange('');
    setIsOpen(false);
  };

  const displayValue = () => {
    if (!value) return placeholder;
    try {
      return format(new Date(value), "MMM d, h:mm a");
    } catch {
      return placeholder;
    }
  };

  const getCalendarDays = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    // Monday-first offset — matches the heatmap calendar header (M T W T F S S)
    const startDayOfWeek = (firstDay.getDay() + 6) % 7;
    const daysInMonth = lastDay.getDate();

    const days: (number | null)[] = [];
    for (let i = 0; i < startDayOfWeek; i++) {
      days.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(i);
    }
    return days;
  };

  const changeMonth = (delta: number) => {
    const newDate = new Date(currentMonth.year, currentMonth.month + delta, 1);
    setCurrentMonth({ year: newDate.getFullYear(), month: newDate.getMonth() });
  };

  const selectDate = (day: number) => {
    const selected = new Date(currentMonth.year, currentMonth.month, day);
    const currentTime = tempDate.split('T')[1] || '12:00';
    const formatted = format(selected, "yyyy-MM-dd") + 'T' + currentTime;
    handleDateSelect(formatted);
  };

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const weekDays = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  const days = getCalendarDays(new Date(currentMonth.year, currentMonth.month, 1));
  const isSelected = (day: number) => {
    if (!value) return false;
    const selectedDate = new Date(value);
    return selectedDate.getDate() === day && 
           selectedDate.getMonth() === currentMonth.month && 
           selectedDate.getFullYear() === currentMonth.year;
  };

  // Tiny "calendar-tile" representation of the picked date — shown on the button
  const valueParts = (() => {
    if (!value) return null;
    try {
      const d = new Date(value);
      return {
        month: d.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
        day: String(d.getDate()).padStart(2, '0'),
        time: format(d, 'h:mm a'),
      };
    } catch { return null; }
  })();

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`gt-btn is-ghost is-sm gt-numerals${fullWidth ? ' w-full justify-center' : ''}`}
        style={{ paddingLeft: 6, paddingRight: 12, gap: 8 }}
      >
        {valueParts ? (
          <>
            {/* Mini calendar tile */}
            <span style={{
              display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
              width: 30, height: 32, borderRadius: 7, overflow: 'hidden', flexShrink: 0,
              border: '1px solid var(--gt-border-strong)',
              background: 'var(--gt-surface-0)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)',
              fontFamily: 'var(--gt-font-display)',
              lineHeight: 1,
            }}>
              <span style={{
                width: '100%',
                background: 'var(--gt-grad-aurora)',
                color: '#ffffff',
                fontSize: 8, fontWeight: 800, letterSpacing: '0.06em',
                padding: '2px 0',
                textAlign: 'center',
              }}>{valueParts.month}</span>
              <span style={{
                fontSize: 14, fontWeight: 800,
                color: 'var(--gt-text-primary)',
                marginTop: 2,
              }}>{valueParts.day}</span>
            </span>
            <span className="whitespace-nowrap" style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1.15 }}>
              <span style={{ fontFamily: 'var(--gt-font-display)', fontWeight: 700, fontSize: 12, color: 'var(--gt-text-primary)' }}>
                {valueParts.month} {valueParts.day}
              </span>
              <span style={{ fontSize: 10.5, color: 'var(--gt-text-tertiary)', marginTop: 1 }}>
                {valueParts.time}
              </span>
            </span>
          </>
        ) : (
          <>
            {icon || <Calendar className="w-4 h-4" />}
            <span className="whitespace-nowrap">{displayValue()}</span>
          </>
        )}
      </button>

      {isOpen && createPortal(
        <>
          <div
            className="fixed inset-0"
            style={{ background: 'rgba(15, 29, 20, 0.32)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)', zIndex: 99998 }}
            onClick={() => setIsOpen(false)}
          />

          <div
            style={{
              position: 'fixed',
              top: `${popupPosition.top}px`,
              left: `${popupPosition.left}px`,
              zIndex: 99999,
            }}
          >
            <div className="gt-cal-panel">
              <div className="gt-cal-head">
                <button
                  type="button"
                  onClick={() => changeMonth(-1)}
                  className="gt-icon-btn is-sm"
                  aria-label="Previous month"
                >
                  <ChevronLeft className="w-4 h-4" />
                </button>
                <span className="gt-cal-month gt-numerals">
                  {monthNames[currentMonth.month]} <em>{currentMonth.year}</em>
                </span>
                <button
                  type="button"
                  onClick={() => changeMonth(1)}
                  className="gt-icon-btn is-sm"
                  aria-label="Next month"
                >
                  <ChevronRight className="w-4 h-4" />
                </button>
              </div>

              <div className="px-4 pt-3 pb-4">
                <div className="grid grid-cols-7 gap-0 mb-1">
                  {weekDays.map((day, i) => (
                    <div key={i} className="gt-cal-weekday" style={{ width: '100%' }}>
                      {day}
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-7 gap-0">
                  {days.map((day, idx) => (
                    <div key={idx} className="aspect-square flex items-center justify-center">
                      {day ? (
                        <button
                          type="button"
                          onClick={() => selectDate(day)}
                          className={`gt-cal-day gt-numerals ${isSelected(day) ? 'is-selected' : ''}`}
                          style={{ width: '100%', height: 32 }}
                        >
                          {day}
                        </button>
                      ) : (
                        <div style={{ width: '100%', height: 32 }} />
                      )}
                    </div>
                  ))}
                </div>

                <div className="gt-rule" style={{ margin: '14px 0 12px' }} />
                <div className="flex gap-3 items-center">
                  <label className="gt-eyebrow" style={{ marginBottom: 0 }}>Time</label>
                  <input
                    type="time"
                    value={tempDate.split('T')[1] || '12:00'}
                    onChange={(e) => setTempDate(prev => `${prev.split('T')[0]}T${e.target.value}`)}
                    className="gt-input gt-numerals"
                    style={{ flex: 1, padding: '8px 12px', fontSize: 13 }}
                  />
                </div>

                <div className="flex gap-2 mt-4">
                  <button
                    type="button"
                    onClick={handleClear}
                    className="gt-btn is-ghost is-sm"
                    style={{ flex: 1, justifyContent: 'center' }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    onClick={handleConfirm}
                    className="gt-btn is-primary is-sm"
                    style={{ flex: 1, justifyContent: 'center' }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
};

// Flat employee picker — opens as a centered modal, lists users (already
// role-scoped on the backend) grouped by role, and lets the user
// multi-select. Returns plain user_ids so the planner can create one Todo
// per recipient via /todo/assign.
const AssigneePicker: React.FC<{
  selected: string[];
  onChange: (next: string[]) => void;
  users: ApiUser[];
  loading: boolean;
  error?: string | null;
  onRetry?: () => void;
  currentUserId?: string | null;
  fullWidth?: boolean;
}> = ({ selected, onChange, users, loading, error, onRetry, currentUserId, fullWidth }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const buttonRef = useRef<HTMLButtonElement>(null);

  const visibleUsers = useMemo(() => {
    // Exclude the caller — checks both `id` and `user_id` since the /users/all
    // payload populates both and either can match currentUserId.
    const list = users.filter(u => {
      const uid = u.id || u.user_id;
      if (!uid) return false;
      if (currentUserId && (uid === currentUserId || u.user_id === currentUserId)) return false;
      return true;
    });
    const q = query.trim().toLowerCase();
    if (!q) return list;
    return list.filter(u =>
      (u.name || "").toLowerCase().includes(q) ||
      (u.role || "").toLowerCase().includes(q) ||
      (u.email || "").toLowerCase().includes(q),
    );
  }, [users, query, currentUserId]);

  // Group by role so the dropdown reads ADMIN / MANAGER / EMPLOYEE …
  const grouped = useMemo(() => {
    const map = new Map<string, ApiUser[]>();
    for (const u of visibleUsers) {
      const role = (u.role || "Other").toString();
      if (!map.has(role)) map.set(role, []);
      map.get(role)!.push(u);
    }
    const priority = ["admin", "manager", "accountant", "hr", "supervisor", "employee"];
    return Array.from(map.entries()).sort(([a], [b]) => {
      const ai = priority.indexOf(a.toLowerCase());
      const bi = priority.indexOf(b.toLowerCase());
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return a.localeCompare(b);
    });
  }, [visibleUsers]);

  // `selected` is already string[]; aliased so the row-render loop below
  // keeps reading like `selectedIds.includes(id)`.
  const selectedIds = selected;

  const toggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onChange(selected.filter(x => x !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setIsOpen(o => !o)}
        className={`gt-btn is-sm${fullWidth ? ' w-full justify-center' : ''} ${selected.length > 0 ? 'is-soft' : 'is-ghost'}`}
        title={selected.length > 0 ? `${selected.length} assigned` : 'Assign to'}
      >
        <Users className="w-3.5 h-3.5" />
        {selected.length > 0 ? `${selected.length} assigned` : 'Assign'}
      </button>

      {isOpen && createPortal(
        <div
          className="fixed inset-0 flex items-center justify-center"
          style={{
            background: 'rgba(15, 29, 20, 0.32)',
            backdropFilter: 'blur(2px)',
            WebkitBackdropFilter: 'blur(2px)',
            zIndex: 99998,
            padding: 16,
          }}
          onMouseDown={() => { setIsOpen(false); setQuery(""); }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              width: 'min(420px, 100%)',
              maxHeight: '80vh',
              zIndex: 99999,
              background: 'var(--gt-surface-0, #fff)',
              border: '1px solid var(--gt-border, #e5e7eb)',
              borderRadius: 14,
              boxShadow: '0 24px 60px -16px rgba(15, 29, 20, 0.36)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <div
              className="flex items-center gap-2 px-3 py-2"
              style={{ borderBottom: '1px solid var(--gt-border, #e5e7eb)' }}
            >
              <Search className="w-3.5 h-3.5 opacity-60" />
              <input
                autoFocus
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search by name or role…"
                className="flex-1 text-sm outline-none bg-transparent"
              />
              {selected.length > 0 && (
                <button
                  type="button"
                  onClick={() => onChange([])}
                  className="text-xs text-red-600 hover:text-red-700"
                >
                  Clear
                </button>
              )}
            </div>

            {/* Fills the centered modal; scrolls when the list overflows. */}
            <div style={{ overflowY: 'auto', flex: 1, minHeight: 200 }}>
              {loading ? (
                <div className="p-4 text-xs text-gray-500 text-center">Loading users…</div>
              ) : error ? (
                <div className="p-4 text-xs text-center">
                  <p className="text-red-600 mb-2">Couldn't load users.</p>
                  <p className="text-gray-500 mb-3 break-words">{error}</p>
                  {onRetry && (
                    <button
                      type="button"
                      onClick={onRetry}
                      className="gt-btn is-ghost is-sm"
                    >
                      Retry
                    </button>
                  )}
                </div>
              ) : grouped.length === 0 ? (
                <div className="p-4 text-xs text-gray-500 text-center italic">
                  {query ? `No users match "${query}".` : 'No users available.'}
                </div>
              ) : (
                grouped.map(([role, list]) => (
                  <div key={role}>
                    <div
                      className="px-3 pt-2 pb-1 text-[10px] font-semibold uppercase tracking-wider"
                      style={{ color: 'var(--gt-text-tertiary, #6b7280)' }}
                    >
                      {role}
                    </div>
                    {list.map((u) => {
                      const id = u.id || u.user_id || "";
                      const checked = selectedIds.includes(id);
                      return (
                        <button
                          key={id}
                          type="button"
                          onClick={() => toggle(id)}
                          className="w-full flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-gray-50 text-left"
                        >
                          <span
                            style={{
                              width: 16, height: 16, borderRadius: 4,
                              border: `2px solid ${checked ? 'var(--gt-primary, #2563eb)' : 'var(--gt-border-strong, #9ca3af)'}`,
                              background: checked ? 'var(--gt-primary, #2563eb)' : 'transparent',
                              color: '#fff',
                              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            {checked && <Check className="w-2.5 h-2.5" strokeWidth={4} />}
                          </span>
                          <span className="flex-1 truncate">
                            <span className="font-medium">{u.name || u.email}</span>
                            {u.email && (
                              <span className="text-xs text-gray-500 ml-1">({u.email})</span>
                            )}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                ))
              )}
            </div>

            <div
              className="flex justify-end gap-2 px-3 py-2"
              style={{ borderTop: '1px solid var(--gt-border, #e5e7eb)' }}
            >
              <button
                type="button"
                onClick={() => { setIsOpen(false); setQuery(""); }}
                className="gt-btn is-primary is-sm"
              >
                Done
              </button>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default function QuickAdd({ onCreate, defaultDate }: Props) {
  // The caller's own id — used to hide "yourself" from the Assign picker so
  // people aren't tempted to assign tasks to themselves from the planner.
  const { user: authedUser } = useAuth();
  const currentUserId = (authedUser as any)?.id || (authedUser as any)?.user_id || null;
  const [open, setOpen] = useState(true);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState<TodoPriority>("MEDIUM");
  const [dueDate, setDueDate] = useState<string>(() => {
    const d = defaultDate || new Date();
    d.setHours(18, 0, 0, 0);
    return format(d, "yyyy-MM-dd'T'HH:mm");
  });
  const [reminderAt, setReminderAt] = useState<string>("");
  const [isRecurring, setIsRecurring] = useState(false);
  const [interval, setInterval] = useState<"DAILY" | "WEEKLY" | "MONTHLY">("DAILY");
  const [markCompleted, setMarkCompleted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [assignees, setAssignees] = useState<string[]>([]);
  const [users, setUsers] = useState<ApiUser[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [usersError, setUsersError] = useState<string | null>(null);
  // Optional client / vendor / project tags ("" = none). Lists are lazy-loaded
  // the first time the composer opens; id→name resolution for planner cards
  // reuses these same lists upstream.
  const [clientId, setClientId] = useState<string>("");
  const [vendorId, setVendorId] = useState<string>("");
  const [projectId, setProjectId] = useState<string>("");
  const [clients, setClients] = useState<Client[]>([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  // File attachments: upload each picked/dropped/pasted file via the API, then
  // keep the returned TodoAttachment refs in local state until submit.
  const [attachments, setAttachments] = useState<TodoAttachment[]>([]);
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const fetchedEntitiesRef = useRef(false);
  const fetchedUsersRef = useRef(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  const loadUsers = React.useCallback(async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);
    setUsersError(null);
    try {
      // Role-scoped list:
      //   • admin / owner / director / founder / superadmin → all branch users
      //   • manager / HOD / HR / team lead → self + direct & indirect reports
      //   • supervisor / employee → self + teammates (same manager_id)
      // Backend enforces the scope; the picker just renders the result
      // grouped by role.
      const res = await getAllUsers({ scope: 'team' });
      setUsers(res?.users || []);
      fetchedUsersRef.current = true;
    } catch (err: any) {
      setUsersError(err?.message || 'Failed to load users');
      fetchedUsersRef.current = false; // allow retry from the picker
    } finally {
      setLoadingUsers(false);
    }
  }, [loadingUsers]);

  // Lazy-load the user list the first time the composer is opened. A ref
  // gates the call so reopening the composer doesn't refetch, and so a
  // re-render while the request is in flight can't cancel it.
  useEffect(() => {
    if (!open || fetchedUsersRef.current || loadingUsers) return;
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Lazy-load client / vendor / project options for the tag dropdowns. Same
  // ref-gated, fire-once pattern as the user list. Failures fall back to empty
  // lists silently — the dropdowns just show "No client/vendor/project".
  useEffect(() => {
    if (!open || fetchedEntitiesRef.current) return;
    fetchedEntitiesRef.current = true;
    clientsApi.list({ page_size: 200 }).then((r) => setClients(r.data?.items || [])).catch(() => {});
    vendorsApi.list({ page_size: 200 }).then((r) => setVendors(r.data?.items || [])).catch(() => {});
    projectsApi.list({ page_size: 200 }).then((r) => setProjects(r.data?.items || [])).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // DO NOTHING → prevent auto close
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Picking a project soft-fills its client/vendor when those are still blank
  // (a project already carries client_id/vendor_id), so the common case needs
  // one pick instead of three. Never overwrites an explicit choice.
  const handleProjectChange = (val: string) => {
    const pid = val === "none" ? "" : val;
    setProjectId(pid);
    if (!pid) return;
    const p = projects.find((x) => x.id === pid);
    if (!p) return;
    if (!clientId && p.client_id) setClientId(p.client_id);
    if (!vendorId && p.vendor_id) setVendorId(p.vendor_id);
  };

  // Human-readable file size, e.g. 512 B, 12 KB, 3.4 MB.
  const formatBytes = (bytes: number): string => {
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const val = bytes / Math.pow(1024, i);
    return `${i === 0 ? val : val.toFixed(val < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
  };

  // Upload each file sequentially and append the returned attachment refs.
  // Failures toast per-file but don't abort the batch.
  const addFiles = async (files: FileList | File[]) => {
    const list = Array.from(files);
    if (list.length === 0) return;
    setUploading(true);
    try {
      for (const file of list) {
        try {
          const res = await todoApi.uploadAttachment(file);
          setAttachments((prev) => [...prev, res.data]);
        } catch (error: any) {
          toast.error(`Couldn't upload ${file.name}`, {
            description: error?.response?.data?.detail || error?.message,
          });
        }
      }
    } finally {
      setUploading(false);
    }
  };

  const removeAttachment = (index: number) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  // Paste (Ctrl+V) support: only hijack the paste when it actually carries
  // files, so ordinary text paste into the notes/title still works.
  const handlePaste = (e: React.ClipboardEvent) => {
    const dt = e.clipboardData;
    if (!dt) return;
    const fromFiles = dt.files ? Array.from(dt.files) : [];
    const fromItems = dt.items
      ? Array.from(dt.items)
          .filter((it) => it.kind === "file")
          .map((it) => it.getAsFile())
          .filter((f): f is File => !!f)
      : [];
    const files = fromFiles.length ? fromFiles : fromItems;
    if (files.length === 0) return; // normal text paste — leave it alone
    e.preventDefault();
    addFiles(files);
  };

  const reset = () => {
    setTitle("");
    setDescription("");
    setPriority("MEDIUM");
    setReminderAt("");
    setIsRecurring(false);
    setMarkCompleted(false);
    setAssignees([]);
    setClientId("");
    setVendorId("");
    setProjectId("");
    setAttachments([]);
  };

  const submit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!title.trim() || submitting) return;
    setSubmitting(true);
    try {
      await onCreate({
        title: title.trim(),
        description: description.trim() || undefined,
        priority,
        status: markCompleted ? "COMPLETED" : "PENDING",
        due_date: dueDate ? format(new Date(dueDate), "yyyy-MM-dd") : undefined,
        reminder_at: reminderAt ? new Date(reminderAt).toISOString() : undefined,
        is_recurring: isRecurring,
        recurrence_rule: isRecurring ? { interval, every: 1 } : undefined,
        client_id: clientId || undefined,
        vendor_id: vendorId || undefined,
        project_id: projectId || undefined,
        assignees: assignees.length > 0 ? assignees : undefined,
        attachments: attachments.length ? attachments : undefined,
      });
      reset();
      setOpen(false);
      toast.success(assignees.length > 0 ? 'Task assigned successfully!' : 'Task added successfully!');
    } catch (error: any) {
      toast.error("Couldn't add task", { description: error?.response?.data?.detail || error.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div ref={containerRef} className="gt-composer relative">
      {!open ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="w-full flex items-center gap-3 px-5 py-4 transition-all"
          style={{ borderRadius: 'var(--gt-radius-sheet)' }}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--gt-surface-hover)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        >
          <span style={{ width: 36, height: 36, borderRadius: 999, background: 'var(--gt-primary)', color: 'var(--gt-on-primary)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', boxShadow: 'var(--gt-elev-2)' }}>
            <Plus className="w-4 h-4" />
          </span>
          <span className="gt-page-sub">Quick-add a task… <em className="gt-serif-italic">(e.g. "Finish payroll review")</em></span>
          <span className="ml-auto hidden md:inline-flex items-center gap-1 gt-kbd">N</span>
        </button>
      ) : (
        <motion.form
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-visible"
          onSubmit={submit}
          onPaste={handlePaste}
        >
          <div className="p-5 space-y-3">
            <div className="flex items-center gap-3">
              <div style={{ width: 36, height: 36, borderRadius: 999, background: 'var(--gt-primary)', color: 'var(--gt-on-primary)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: 'var(--gt-elev-2)' }}>
                <Plus className="w-4 h-4" />
              </div>
              <input
                ref={inputRef}
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="What needs doing?"
                className="gt-quickadd-title"
                style={{
                  flex: 1, background: 'transparent', border: 0, outline: 'none', boxShadow: 'none',
                  borderBottom: '1px solid var(--gt-border)',
                  padding: '6px 0',
                  fontSize: 16, fontWeight: 600,
                  fontFamily: 'var(--gt-font-display)',
                  color: 'var(--gt-text-primary)',
                  letterSpacing: '-0.01em',
                }}
                onKeyDown={(e) => {
                  if (e.key === "Escape") { setOpen(false); reset(); }
                  if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); }
                }}
              />
              <button
                type="button"
                onClick={() => { setOpen(false); reset(); }}
                className="gt-icon-btn is-sm"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <textarea
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
              }}
              placeholder="Notes (optional)"
              rows={2}
              className="gt-textarea"
              style={{ resize: 'none', overflow: 'hidden', background: 'var(--gt-surface-2)', border: '1px solid transparent' }}
            />

            {/* Attachments — click, drag & drop, or paste (Ctrl+V) */}
            <div className="hidden">
              <input
                ref={fileInputRef}
                type="file"
                multiple
                className="hidden"
                onChange={(e) => {
                  if (e.target.files) addFiles(e.target.files);
                  e.target.value = ""; // allow re-selecting the same file
                }}
              />

              <div
                role="button"
                tabIndex={0}
                onClick={() => fileInputRef.current?.click()}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInputRef.current?.click(); }
                }}
                onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={(e) => { e.preventDefault(); setDragOver(false); }}
                onDrop={(e) => { e.preventDefault(); setDragOver(false); addFiles(e.dataTransfer.files); }}
                className={`flex items-center gap-2 w-full px-3 py-2.5 rounded-xl border border-dashed cursor-pointer text-sm transition-colors ${
                  dragOver
                    ? "border-emerald-500 bg-emerald-50 text-emerald-700"
                    : "border-gray-300 bg-gray-50 text-gray-500 hover:border-emerald-400 hover:text-emerald-600"
                }`}
                aria-label="Attach files"
              >
                <Paperclip className="w-4 h-4 flex-shrink-0" />
                <span>Attach files</span>
                <span className="ml-auto text-xs text-gray-400">Drop, click, or paste</span>
              </div>

              {uploading && (
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                  <span>Uploading…</span>
                </div>
              )}

              {attachments.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {attachments.map((att, i) => (
                    <span
                      key={`${att.url}-${i}`}
                      className="inline-flex items-center gap-1.5 max-w-full pl-3 pr-1.5 py-1 rounded-full border border-gray-200 bg-white text-xs text-gray-700"
                    >
                      <a
                        href={attachmentHref(att.url)}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="truncate max-w-[180px] hover:text-emerald-600 hover:underline"
                        title={att.name}
                      >
                        {att.name}
                      </a>
                      <span className="text-gray-400 flex-shrink-0">({formatBytes(att.size)})</span>
                      <button
                        type="button"
                        onClick={() => removeAttachment(i)}
                        className="flex-shrink-0 inline-flex items-center justify-center w-4 h-4 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                        aria-label={`Remove ${att.name}`}
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="flex flex-wrap gap-2 items-center relative">
              <div className="w-[150px]">
                <ModernDateTimePicker
                  value={dueDate}
                  onChange={setDueDate}
                  icon={<Calendar className="w-4 h-4" />}
                  fullWidth
                />
              </div>

              <div className="w-[150px]">
                <Select value={priority} onValueChange={(v) => setPriority(v as TodoPriority)}>
                  <SelectTrigger className="rounded-full">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, overflow: 'hidden' }}>
                      <Flag className="w-3.5 h-3.5" style={{ flexShrink: 0 }} />
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><SelectValue /></span>
                    </span>
                  </SelectTrigger>
                  <SelectContent>
                    {PRIORITIES.map((p) => (
                      <SelectItem key={p.v} value={p.v}>{p.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="w-[150px]">
                <ModernDateTimePicker
                  value={reminderAt}
                  onChange={setReminderAt}
                  placeholder="Reminder"
                  icon={<Bell className="w-4 h-4" />}
                  fullWidth
                />
              </div>

              <button
                type="button"
                onClick={() => setIsRecurring((v) => !v)}
                className={`gt-btn is-sm w-[150px] justify-center ${isRecurring ? 'is-soft' : 'is-ghost'}`}
              >
                <Repeat className="w-3.5 h-3.5" /> Recurring
              </button>

              {isRecurring && (
                <div className="w-[150px]">
                  <Select value={interval} onValueChange={(v) => setInterval(v as any)}>
                    <SelectTrigger className="rounded-full"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="DAILY">Daily</SelectItem>
                      <SelectItem value="WEEKLY">Weekly</SelectItem>
                      <SelectItem value="MONTHLY">Monthly</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              )}

              <button
                type="button"
                onClick={() => setMarkCompleted((v) => !v)}
                className={`gt-btn is-sm w-[150px] justify-center ${markCompleted ? 'is-accent' : 'is-ghost'}`}
                title="Add as already completed"
              >
                <CheckCircle2 className="w-3.5 h-3.5" /> Completed
              </button>

              <div className="w-[150px]">
                <Select value={clientId || "none"} onValueChange={(v) => setClientId(v === "none" ? "" : v)}>
                  <SelectTrigger className="rounded-full">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, overflow: 'hidden' }}>
                      <Building2 className="w-3.5 h-3.5" style={{ flexShrink: 0 }} />
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><SelectValue placeholder="Client" /></span>
                    </span>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">No client</SelectItem>
                    {clients.map((c) => (
                      <SelectItem key={c.id} value={c.id}>{c.clientName}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="w-[150px]">
                <Select value={vendorId || "none"} onValueChange={(v) => setVendorId(v === "none" ? "" : v)}>
                  <SelectTrigger className="rounded-full">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, overflow: 'hidden' }}>
                      <Truck className="w-3.5 h-3.5" style={{ flexShrink: 0 }} />
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><SelectValue placeholder="Vendor" /></span>
                    </span>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">No vendor</SelectItem>
                    {vendors.map((v) => (
                      <SelectItem key={v.id} value={v.id}>{v.clientName}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="w-[150px]">
                <Select value={projectId || "none"} onValueChange={handleProjectChange}>
                  <SelectTrigger className="rounded-full">
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, overflow: 'hidden' }}>
                      <FolderKanban className="w-3.5 h-3.5" style={{ flexShrink: 0 }} />
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}><SelectValue placeholder="Project" /></span>
                    </span>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">No project</SelectItem>
                    {projects.map((p) => (
                      <SelectItem key={p.id} value={p.id}>{p.name}{p.client_name ? ` — ${p.client_name}` : ''}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="w-[150px]">
                <AssigneePicker
                  selected={assignees}
                  onChange={setAssignees}
                  users={users}
                  loading={loadingUsers}
                  error={usersError}
                  onRetry={loadUsers}
                  currentUserId={currentUserId}
                  fullWidth
                />
              </div>

              <div
                role="button"
                tabIndex={0}
                onClick={() => fileInputRef.current?.click()}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInputRef.current?.click(); }
                }}
                onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={(e) => { e.preventDefault(); setDragOver(false); }}
                onDrop={(e) => { e.preventDefault(); setDragOver(false); addFiles(e.dataTransfer.files); }}
                className={`flex items-center gap-2 w-[150px] max-w-full px-3 py-2.5 rounded-full border border-dashed cursor-pointer text-sm transition-colors ${
                  dragOver
                    ? "border-emerald-500 bg-emerald-50 text-emerald-700"
                    : "border-gray-300 bg-gray-50 text-gray-500 hover:border-emerald-400 hover:text-emerald-600"
                }`}
                aria-label="Attach files"
              >
                <Paperclip className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">Attach files</span>
                {uploading && <Loader2 className="ml-auto w-3.5 h-3.5 animate-spin flex-shrink-0" />}
              </div>

              <button
                type="submit"
                disabled={!title.trim() || submitting}
                className="gt-btn is-primary ml-auto"
              >
                {submitting
                  ? (assignees.length > 0 ? 'Assigning…' : 'Planning…')
                  : (assignees.length > 0 ? 'Assign' : 'Plan')}
                <span className="hidden md:inline-flex gt-btn-kbd">⏎</span>
              </button>
            </div>

            {attachments.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {attachments.map((att, i) => (
                  <span
                    key={`${att.url}-${i}`}
                    className="inline-flex items-center gap-1.5 max-w-full pl-3 pr-1.5 py-1 rounded-full border border-gray-200 bg-white text-xs text-gray-700"
                  >
                    <a
                      href={attachmentHref(att.url)}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="truncate max-w-[180px] hover:text-emerald-600 hover:underline"
                      title={att.name}
                    >
                      {att.name}
                    </a>
                    <span className="text-gray-400 flex-shrink-0">({formatBytes(att.size)})</span>
                    <button
                      type="button"
                      onClick={() => removeAttachment(i)}
                      className="flex-shrink-0 inline-flex items-center justify-center w-4 h-4 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                      aria-label={`Remove ${att.name}`}
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>
        </motion.form>
      )}
    </div>
  );
}
